export default {
  data: {
    type: Array,
    default: () => ([])
  },
  title: {
    type: String,
    required: true
  },
  rule: {
    type: String,
    required: true
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/preview/resources/props.js